export const stagesList = {
  outreach_in_progress: {
    id: 'outreach_in_progress',
    label: 'Flow in-progress',
    filterable: true,
    updatable: false,
    color: '#FFD600',
    group: 'outreach',
  },
  outreach_failed: {
    id: 'outreach_failed',
    label: 'Flow failed',
    filterable: true,
    updatable: false,
    color: '#EB4a27',
    group: 'outreach',
  },
  outreach_enrich: {
    id: 'outreach_enrich',
    label: 'Enrichment in-progress',
    filterable: false,
    updatable: false,
    color: '#EB4a27',
    group: 'outreach',
  },
  outreach_replied: {
    id: 'outreach_replied',
    label: 'Flow replied',
    filterable: true,
    updatable: false,
    color: '#64dd17',
    group: 'outreach',
  },
  outreach_not_replied: {
    id: 'outreach_not_replied',
    label: 'Flow not-replied',
    filterable: true,
    updatable: false,
    color: 'var(--kula-dark-secondary-700, #78909c)',
    group: 'outreach',
  },
  outreach_interested: {
    id: 'outreach_interested',
    label: 'Flow interested',
    filterable: true,
    updatable: false,
    color: '#9c27B0',
    group: 'outreach',
  },
  outreach_not_interested: {
    id: 'outreach_not_interested',
    label: 'Flow not-interested',
    filterable: true,
    updatable: false,
    color: '#ff4081',
    group: 'outreach',
  },
  candidate_interested: {
    id: 'candidate_interested',
    label: 'Flow candidate interested',
    filterable: false,
    updatable: true,
    color: '#9c27B0',
    group: 'outreach',
  },
  outreach_stopped: {
    id: 'outreach_stopped',
    label: 'Flow stopped',
    filterable: true,
    updatable: false,
    color: 'var(--kula-colors-pastel-8-dark, #880e4f)',
    group: 'outreach',
  },
  outreach_paused: {
    id: 'outreach_paused',
    label: 'Flow paused',
    filterable: true,
    updatable: false,
    color: 'var(--kula-dark-secondary-800, #6d4c41)',
    group: 'outreach',
  },
  outreach_completed: {
    id: 'outreach_completed',
    label: 'Flow completed',
    filterable: true,
    updatable: false,
    color: 'var(--kula-dark-primary-700, #0025EA)',
    group: 'outreach',
  },
  candidate_not_interested: {
    id: 'candidate_not_interested',
    label: 'Flow not-interested',
    filterable: false,
    updatable: true,
    color: '#ff4081',
    group: 'outreach',
  },

  in_review: {
    id: 'in_review',
    label: 'In-review',
    filterable: true,
    updatable: true,
    color: 'var(--kula-dark-secondary-700, #839daa)',
    group: 'screening',
  },
  screen: {
    id: 'screen',
    label: 'Recruiter-screening',
    filterable: true,
    updatable: true,
    color: '#8DE2DB',
    group: 'screening',
  },
  team_screen: {
    id: 'team_screen',
    label: 'Team-screening',
    filterable: true,
    updatable: true,
    color: '#766BF0',
    group: 'screening',
  },
  onsite: {
    id: 'onsite',
    label: 'Onsite',
    filterable: true,
    updatable: true,
    color: 'var(--kula-dark-primary-700, #0085ff)',
    group: 'screening',
  },
  offer: {
    id: 'offer',
    label: 'Offered',
    filterable: true,
    updatable: true,
    color: '#239342',
    group: 'screening',
  },
  hired: {
    id: 'hired',
    label: 'Hired',
    filterable: true,
    updatable: true,
    color: '#1de9b6',
    group: 'screening',
  },

  screen_reject: {
    id: 'screen_reject',
    label: 'Recruiter-screening rejected',
    filterable: true,
    updatable: true,
    color: '#F3684A',
    group: 'rejected',
  },
  team_screen_reject: {
    id: 'team_screen_reject',
    label: 'Team-screen rejected',
    filterable: true,
    updatable: true,
    color: '#EB4A27',
    group: 'rejected',
  },
  onsite_reject: {
    id: 'onsite_reject',
    label: 'Onsite rejected',
    filterable: true,
    updatable: true,
    color: '#ff7a72',
    group: 'rejected',
  },

  rejected: {
    id: 'rejected',
    label: 'Rejected',
    filterable: true,
    updatable: true,
    color: '#b71c1c',
    group: 'rejected',
  },

  offer_reject: {
    id: 'offer_reject',
    label: 'Offer declined',
    filterable: true,
    updatable: true,
    color: '#E94D5C',
    group: 'candidate_rejected',
  },
};

export const flowStagesList = {
  in_progress: {
    id: 'in_progress',
    label: 'Flow in-progress',
    filterable: true,
    updatable: false,
    color: '#FFD600',
    group: 'outreach',
  },
  stopped_no_email: {
    id: 'stopped_no_email',
    label: 'Flow failed',
    filterable: true,
    updatable: false,
    color: '#EB4a27',
    group: 'outreach',
  },
  bounced: {
    id: 'bounced',
    label: 'Flow Bounced',
    filterable: true,
    updatable: false,
    color: '#EB4a27',
    group: 'outreach',
  },
  replied: {
    id: 'replied',
    label: 'Flow replied',
    filterable: true,
    updatable: false,
    color: '#64dd17',
    group: 'outreach',
  },
  no_reply: {
    id: 'no_reply',
    label: 'Flow not-replied',
    filterable: true,
    updatable: false,
    color: 'var(--kula-dark-secondary-700, #78909c)',
    group: 'outreach',
  },
  candidate_interested: {
    id: 'candidate_interested',
    label: 'Flow interested',
    filterable: false,
    updatable: true,
    color: '#9c27B0',
    group: 'outreach',
  },
  stopped: {
    id: 'stopped',
    label: 'Flow stopped',
    filterable: true,
    updatable: false,
    color: 'var(--kula-colors-pastel-8-dark, #880e4f)',
    group: 'outreach',
  },
  enrich: {
    id: 'enrich',
    label: 'Enrichment in-progress',
    filterable: false,
    updatable: false,
    color: 'var(--kula-colors-pastel-8-dark, #880e4f)',
    group: 'outreach',
  },
  paused: {
    id: 'paused',
    label: 'Flow paused',
    filterable: true,
    updatable: false,
    color: 'var(--kula-dark-secondary-800, #6d4c41)',
    group: 'outreach',
  },
  completed: {
    id: 'completed',
    label: 'Flow completed',
    filterable: true,
    updatable: false,
    color: 'var(--kula-dark-primary-700, #0025EA)',
    group: 'outreach',
  },
  candidate_not_interested: {
    id: 'candidate_not_interested',
    label: 'Flow not-interested',
    filterable: false,
    updatable: true,
    color: '#ff4081',
    group: 'outreach',
  },
};

export const stages = Object.values(stagesList);
export const flowStages = Object.values(flowStagesList);
export const userUpdatableStage = Object.values(stagesList).filter(
  ({ updatable }) => updatable
);
export const userUpdatableFlowStage = Object.values(flowStagesList).filter(
  ({ updatable }) => updatable
);
export const userUpdatableNonFlowStage = Object.values(stagesList).filter(
  ({ updatable, group }) => updatable && group !== 'outreach'
);

export const stageGroup = {
  outreach: {
    label: 'Flow',
  },
  screening: {
    label: 'Screening',
  },
  rejected: {
    label: 'We rejected them',
  },
  candidate_rejected: {
    label: 'They Rejected us',
  },
};

export const rejectionStage = [
  'screen_reject',
  'team_screen_reject',
  'onsite_reject',
  'offer_reject',
  'rejected',
  'outreach_not_interested',
  'candidate_not_interested',
];

export const atsStage = {
  ...stagesList,
  outreach_draft: {
    id: 'outreach_draft',
    label: 'Flow in-draft',
  },
};
